// extracted by mini-css-extract-plugin
module.exports = {"lds-spinner":"preloader_lds-spinner__3hICi","primary":"preloader_primary__CGk4E","secondary":"preloader_secondary___6Bga"};